
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexTr_45aYhNnF5pu5zRsNFnUwvya8n5USB7LzB_45Fs0lv_AMMeta } from "/app/modules/dashboard/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as rolesASFo9P3Rgf6vBvUT16SL7_51yonITdf2p4ubFWv2ycYMeta } from "/app/pages/roles.vue?macro=true";
import { default as _91id_93WakUUi_453DQQ2BIADVSHKTBr7I0hoj1jZv6o6dBrK7ykMeta } from "/app/modules/crm/pages/crm/[id].vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as indexl_g2QEN_lgqH7N7TU6My0xi1WJOIBrLliYFr6Ye8fXoMeta } from "/app/modules/acl/pages/acl/index.vue?macro=true";
import { default as cmsPQTvFc5CJjBWIVLH85C_w3MkbIw0HTAk3egAPHr1ZncMeta } from "/app/pages/admin/cms.vue?macro=true";
import { default as indexgFc3XCj6BHaZDPvZAXMUTnIODIyIsqDKpzxAc0YoxIAMeta } from "/app/modules/crm/pages/crm/index.vue?macro=true";
import { default as indexrR_SEkare_45AM9Tgp_PCaUILQx0avTztbKm94zfTUzBgMeta } from "/app/modules/hrm/pages/hrm/index.vue?macro=true";
import { default as mediahpbreO2XnTr_45BpFIFHIKzYdEzn7l24rhqX2IfBy7ZEIMeta } from "/app/modules/hrm/pages/hrm/media.vue?macro=true";
import { default as indexBfzup7ozt912qrHTa1aaC5eGV6nQWXCzI1RQdW4oyP4Meta } from "/app/modules/pos/pages/pos/index.vue?macro=true";
import { default as createSh5SwCOE7dT0JW70qsV2qMdglSRz1HI6VXJxXHJqSpgMeta } from "/app/modules/acl/pages/acl/create.vue?macro=true";
import { default as activationippIn2nyEqGEt9rKOkhAwAh_8AaYz2KNMvz94G_45WnwcMeta } from "/app/modules/license/pages/activation.vue?macro=true";
import { default as leaveshWbya_45IjGM8WT1LFOaTBNYwmSPg1Fi7IXmUevBEtKY0Meta } from "/app/modules/hrm/pages/hrm/leaves.vue?macro=true";
import { default as _91id_937lfVCIoCog4ZIR5kyPDel_45yFf7XfMUS0g711dL_XqkUMeta } from "/app/modules/sales/pages/sales/[id].vue?macro=true";
import { default as _91id_93vRziCnkfDlYi7bbsyGHFZRb3nzh66kjbkpqIAWCD3OQMeta } from "/app/modules/users/pages/users/[id].vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as payslips9AIBoFUSEBKqKQFEE7I5GIgGEWoP6Uk4Ls6JyDWCHgIMeta } from "/app/modules/hrm/pages/hrm/payroll/payslips.vue?macro=true";
import { default as payroll_45runscnf5sD2gPajgr1hYSPa3CyqPzT_45omxa1sQ8e6ZJZILcMeta } from "/app/modules/hrm/pages/hrm/payroll/payroll-runs.vue?macro=true";
import { default as employee_45salariesWUYgSA3kJFbd6uhLiHOkHH5VH8JLp2Iz1O71HORsT0EMeta } from "/app/modules/hrm/pages/hrm/payroll/employee-salaries.vue?macro=true";
import { default as salary_45components_IawvmLUXeSshiuefXJrMSceVvH7cCJGJfQa1NcRWLwMeta } from "/app/modules/hrm/pages/hrm/payroll/salary-components.vue?macro=true";
import { default as payrollRTIkFBVglb4iZmP6Gooi1HaxlObC7xcfISWhtPrDbIkMeta } from "/app/modules/hrm/pages/hrm/payroll.vue?macro=true";
import { default as permissionseZNWYkKVui6eCCssuowxz3khlCPpLdsvK0YaaOEfb74Meta } from "/app/pages/permissions.vue?macro=true";
import { default as indexxG6Dh99LL_SYZAy8PO2u3j10ub4_45hySF5mfma1Wdk3EMeta } from "/app/modules/sales/pages/sales/index.vue?macro=true";
import { default as index3DbT5RW8O7wxIyGp2_9jh_oPsOlH8_454KXTIJ1xcdurwMeta } from "/app/modules/users/pages/users/index.vue?macro=true";
import { default as indexFqSpGuue51kjflzjuxVSEs_45C4bxHvcNT37vXlhHtiT4Meta } from "/app/modules/hrm/pages/hrm/branches/index.vue?macro=true";
import { default as branchesvyUjVP_z67OcAINM5_45fakidif8HhATngrZ_45LLk1xeiIMeta } from "/app/modules/hrm/pages/hrm/branches.vue?macro=true";
import { default as calendarSIydakh2zAkbblJGLIQ4FD0KiywiRV9ExZiwT7EwSY4Meta } from "/app/modules/hrm/pages/hrm/calendar.vue?macro=true";
import { default as holidaysin0Doy5PcM_TZjJE4vlAfy89Ic0h_45FhGFFIGQBQ5mxgMeta } from "/app/modules/hrm/pages/hrm/holidays.vue?macro=true";
import { default as settingsa49NA_o6MUHRZoQSDY5tnyax_R00LRtZxEeBQLIX_tQMeta } from "/app/modules/hrm/pages/hrm/settings.vue?macro=true";
import { default as createxiGGVVIQXm3cbKasi_45R_45gIsGLyHW9tKb3b15UTJXYxgMeta } from "/app/modules/sales/pages/sales/create.vue?macro=true";
import { default as createo0jvoDJbt9ORvRSgwegB4_45koHm5Us_gRPdyB78hKvdsMeta } from "/app/modules/users/pages/users/create.vue?macro=true";
import { default as _91id_93NMLhCRrJCEPH2ELrbflmfDTkYuimaq0rZxscsHXuYmMMeta } from "/app/modules/acl/pages/acl/edit/[id].vue?macro=true";
import { default as _91_46_46_46slug_93Ov0iNio0Tzx9AYqmBDuIBw0trmJ4GCS5ntz6chKse6MMeta } from "/app/modules/hrm/pages/hrm/[...slug].vue?macro=true";
import { default as biometricsiLYqyLJZl6d_45mOVX3TKbdXTTD9uRu4T1UH_cUpUX8AMeta } from "/app/modules/hrm/pages/hrm/biometric.vue?macro=true";
import { default as indexjx6LjdO5XtBgB5bme7FqLjIx8rRqWq2WMhLcpUcH6LgMeta } from "/app/modules/loyalty/pages/loyalty/index.vue?macro=true";
import { default as _91id_93KQ8oUpin1NciPMwgP5sypFMxIHL5V8lW_BZ65SNMEm8Meta } from "/app/modules/products/pages/products/[id].vue?macro=true";
import { default as indexhxcvNuY183wInhucHQGQk9ZCtbSMyvYobG1YVXvcwhUMeta } from "/app/modules/reports/pages/reports/index.vue?macro=true";
import { default as salesYzzSYWave3cGqYIixm7FMBQJcQTfZp32O2HTVHvBpFcMeta } from "/app/modules/reports/pages/reports/sales.vue?macro=true";
import { default as indexanGPuoIseCMZNwqAtgMMO9TYZzKGJRkvmvk2qQPGYO8Meta } from "/app/modules/accounts/pages/accounts/index.vue?macro=true";
import { default as paymentsDTc0YZeXYu6Cf6_beJ0BxGHbRp8hOu0wiiCt4WRp_lEMeta } from "/app/pages/admin/payments.vue?macro=true";
import { default as indexwVoB8CJsWkJZJaqSlpWNcn2Ew1cAVx8YB4PMxaznPtUMeta } from "/app/modules/business/pages/business/index.vue?macro=true";
import { default as indexbQIS1Nkd1Bc05tQiDZ2C28O1H7bgqu64bYThQl_KTo8Meta } from "/app/modules/expenses/pages/expenses/index.vue?macro=true";
import { default as _91resource_93BcyQ6zTJuZ8_eCAOzRuqIaEcS0S1DXYqe80l9DU8VF0Meta } from "/app/modules/hrm/pages/hrm/[resource].vue?macro=true";
import { default as attendance7_9yZF6J1jRq0_45RpN29rHmrwq4exK587lkMrvjvQ_zsMeta } from "/app/modules/hrm/pages/hrm/attendance.vue?macro=true";
import { default as indexvZo1JHvPox3IVt1eN_In_45X7zcDuqKzsNklF1aGyGbBMMeta } from "/app/modules/products/pages/products/index.vue?macro=true";
import { default as _91id_93ZEgOJor7drR_45RE_45YIxy5IM3ZUNcwZ1zksWfVweQnZqAMeta } from "/app/modules/purchase/pages/purchases/[id].vue?macro=true";
import { default as index88TNPJQdXLFrsPDyn41dVLPYqiyCzn1T_45wUd_hNn_45LkMeta } from "/app/modules/settings/pages/settings/index.vue?macro=true";
import { default as setup_45businessXAb_45EmVnanlKFQXZ6P5ZhsYFE6QHXOpbbS_7PCUMBZQMeta } from "/app/pages/setup-business.vue?macro=true";
import { default as _91id_93_09CEgG88ME7YBmOry_8Cc5SUHdRqKlaBjlgH0KcxEMMeta } from "/app/modules/transfers/pages/transfers/[id].vue?macro=true";
import { default as index7k5RtnDifftRpA_f70jEQL4EOQ3gGaYEQykls4yOoikMeta } from "/app/modules/whatsapp/pages/whatsapp/index.vue?macro=true";
import { default as ledgerZlgCWic9E1kgvQd9lfylJAIpLxYT2JIArFxUf1WMqpcMeta } from "/app/modules/accounts/pages/accounts/ledger.vue?macro=true";
import { default as inquiriesDHjVjxvsJHbkshR_qJplFBSJ3Wy80y9_XEUc0wzTnWQMeta } from "/app/pages/admin/inquiries.vue?macro=true";
import { default as createzbpaj_45hsiPJGtK_PJswrgiopS3o0C32iu0Ur2Sx8i0sMeta } from "/app/modules/expenses/pages/expenses/create.vue?macro=true";
import { default as indexWto_45dQaB0HPYvPKcR0ERaClHo2BCSooqihyA7KSccsoMeta } from "/app/modules/hrm/pages/hrm/departments/index.vue?macro=true";
import { default as departmentsyqKZb74chvNbfWXMsShsc3MLVZmFJtq6DA_puSJsxjAMeta } from "/app/modules/hrm/pages/hrm/departments.vue?macro=true";
import { default as types17Ne9GWVTsJ4IjWyYQIPyzO5af6T0LrmzRaKholqI3cMeta } from "/app/modules/hrm/pages/hrm/leave/types.vue?macro=true";
import { default as createNR5wcTGqn9draBW4uYN2fKAdEqo5YadEWmXUpLpasG0Meta } from "/app/modules/products/pages/products/create.vue?macro=true";
import { default as index43nbVDKbC5kzHEkahe1Z_PCBvUGSXDsWUmzP6BjV75kMeta } from "/app/modules/purchase/pages/purchases/index.vue?macro=true";
import { default as index3KoEmFlQuSHQcfWwNn2TSXNkv4wuZNmUC4XV8fbkXVoMeta } from "/app/modules/transfers/pages/transfers/index.vue?macro=true";
import { default as indexRhv_HzdjqIGTVMcIhjFjAjRVr_45CIKGsIpcd24IDmMekMeta } from "/app/modules/warehouse/pages/warehouse/index.vue?macro=true";
import { default as bankingxfGI_OTF7ntFo_Iret_efAstTE_8u_45Csei_45_FFYfsRcMeta } from "/app/modules/accounts/pages/accounts/banking.vue?macro=true";
import { default as currenciesPHUq72lrQhgaPP98Dpbbut_sBLLRmj5tL9zzrVFJTLwMeta } from "/app/pages/admin/currencies.vue?macro=true";
import { default as indexSE_458_45Cec6nT7RKRuYnsOHR3FS80bFGq4QfJwm9kFT5EMeta } from "/app/modules/hrm/pages/hrm/assets/index.vue?macro=true";
import { default as indexGbdchlrChgxoAQqyXgpAzFyGl2vqJ4e5IY0qZZi0VBoMeta } from "/app/modules/hrm/pages/hrm/designations/index.vue?macro=true";
import { default as designationsRp9cav86BzvGPJtl4zTIlSln5gvnD7D82c__45ae_4F6IMeta } from "/app/modules/hrm/pages/hrm/designations.vue?macro=true";
import { default as landing_45page6ke7IZP7kPikiqhnF0_RFYfhkPRg2xBzcuWnVjaRf4MMeta } from "/app/modules/hrm/pages/hrm/landing-page.vue?macro=true";
import { default as createB2H8hxCbe69NaTrUXq_2gDmbarTIDV5YeOToWSm2wcwMeta } from "/app/modules/purchase/pages/purchases/create.vue?macro=true";
import { default as purchasejklImxD77LpXS2VgGtielTlnAtxapwmA8uc0HJZBe4MMeta } from "/app/modules/reports/pages/reports/purchase.vue?macro=true";
import { default as createBDaTvI_djACr_457WbJwnYkSZRA1nX9TlczumeWO_45h9BwMeta } from "/app/modules/transfers/pages/transfers/create.vue?macro=true";
import { default as vouchers_DyAzMJhwERK5egbg_45CcIMiHavtz592NN0wepdQn0oEMeta } from "/app/modules/accounts/pages/accounts/vouchers.vue?macro=true";
import { default as indexosy7mpftrqlOM67BGMfQd4bp1j6kTWL8hyY3kgUWp4cMeta } from "/app/pages/admin/plans/index.vue?macro=true";
import { default as indexgvs7WdV1NLBsiIM1p5V4txUPTMYikQ1vfsYYESmgxtgMeta } from "/app/pages/admin/users/index.vue?macro=true";
import { default as listfpw6G0aq11V8OVxA1OhIvtVHpE3_45rqfz38kjVLOY2O4Meta } from "/app/modules/hrm/pages/hrm/meetings/list.vue?macro=true";
import { default as createdTfT88WuD_45o_Mf1kiXM_45CsWZbBlFva0hPQKhluysxcQMeta } from "/app/pages/admin/plans/create.vue?macro=true";
import { default as transactionsis8acS5wHQrmoknTYhldrYvX6omIov7V_45HYkC3TU2FIMeta } from "/app/pages/admin/transactions.vue?macro=true";
import { default as createvTtCW9JjGhbwMa0VlEmmMf_wKNGasc6FZhv9u4Fqt_450Meta } from "/app/pages/admin/users/create.vue?macro=true";
import { default as _91id_93sAVzEtupnVvhfsZVEA6DHb2VYHr5bGPbFEkh3JAG1jMMeta } from "/app/modules/expenses/pages/expenses/edit/[id].vue?macro=true";
import { default as _91id_93rtT99T1_WWp8p8dRJNsBW9c4A_m8ffFhL_45zimWvPq14Meta } from "/app/modules/hrm/pages/hrm/employees/[id].vue?macro=true";
import { default as balanceszWMG_7up3QdweXKxBNLKHxBcoR5oCXaj__55m4DCoEoMeta } from "/app/modules/hrm/pages/hrm/leave/balances.vue?macro=true";
import { default as policiesYmbckDSim6FCeWtjeARqv7u3qPg85QakvecBEB_DGlAMeta } from "/app/modules/hrm/pages/hrm/leave/policies.vue?macro=true";
import { default as indexgjfX05Dzz493sFx3V_45UQ8m8vWMHksANNlJhKq0k3jYUMeta } from "/app/modules/hrm/pages/hrm/training/index.vue?macro=true";
import { default as low_45stock0fnEsQBfc6L_45_Ii8oq_u8enH5JNvps_7H39en2qstagMeta } from "/app/modules/products/pages/products/low-stock.vue?macro=true";
import { default as _91id_93eFQBiwc_xZJKQMNykTq7XixXevBtCp93zB3O9Zhu_54Meta } from "/app/modules/reports/pages/reports/stock/[id].vue?macro=true";
import { default as customer_45dueuFGzdPpjM4y6LKIzFcZYBZHbycVkJ1x6LPqvyuTX7qIMeta } from "/app/modules/sales/pages/sales/customer-due.vue?macro=true";
import { default as _91id_93wFSb7_45A4ilhFzfDXdlCgEPLBkFVgNF_oKC_u6z3beiYMeta } from "/app/modules/sales/pages/sales/returns/[id].vue?macro=true";
import { default as _91id_9342x_cWd2qXzgfqRN8V_geXxsCDaYYd0WSpzyce3v6NQMeta } from "/app/modules/accounts/pages/accounts/loans/[id].vue?macro=true";
import { default as subscriptionsAS0WW2vkVJeFG6ogK8uSyrnmSsY6dW0mDIARAWkPFwQMeta } from "/app/pages/admin/subscriptions.vue?macro=true";
import { default as indexQ3tdZS10mF2Ol3ibbvjtN_45KoXJEOaaZHq_45e7Sdg5bTAMeta } from "/app/modules/hrm/pages/hrm/employees/index.vue?macro=true";
import { default as profit_45lossiWsoRzE2lXTI2WTDS_45G_451X2iESSTQaNTrcG28AJn_rMMeta } from "/app/modules/reports/pages/reports/profit-loss.vue?macro=true";
import { default as indexrOHW26Fhwtcbf1zvk2_YXRuwPe2LpWEJgJ5dldj_h0AMeta } from "/app/modules/reports/pages/reports/stock/index.vue?macro=true";
import { default as indexjPYWIcKrLd2uW_45Kwjdb_45_45tc5vpd3Jff9afsdZdY7_458oMeta } from "/app/modules/sales/pages/sales/returns/index.vue?macro=true";
import { default as _91id_93MX1oFLBDsUOrLFnNUg6vbK2HTGAlzRH5ZIFJkK6ZWHEMeta } from "/app/modules/transfers/pages/transfers/edit/[id].vue?macro=true";
import { default as index_45XnrqC1E6KRP8zl9AcSgj7K4Dkom49fxTgoo2siBBHQMeta } from "/app/modules/accounts/pages/accounts/loans/index.vue?macro=true";
import { default as index6_45NrOzolDHARn55tJTkDc7i6bgEnjEUOmZyMGwF5aBsMeta } from "/app/pages/admin/settings/index.vue?macro=true";
import { default as _91_46_46_46slug_9371oHFru7Cl2amvYnwW4Pb4bSn8v_Dd9EkX8eTgqK748Meta } from "/app/modules/hrm/pages/hrm/assets/[...slug].vue?macro=true";
import { default as createTdlO7GcvVNU4BKOdZfV3nvf_d8pfydv238GKgJIJiZEMeta } from "/app/modules/hrm/pages/hrm/employees/create.vue?macro=true";
import { default as _91resource_93RBRxiDhGqNIk4YNHceSGQcztQheBXXjt6d0XRrJhoMwMeta } from "/app/modules/hrm/pages/hrm/plans/[resource].vue?macro=true";
import { default as indexeSkkl4yRbjTEDB6s_45cARWqLWIMBixOaoKexvE_xK65wMeta } from "/app/modules/products/pages/products/units/index.vue?macro=true";
import { default as createvBF9qxmWpEFqLGX8TnOkjtxwnR7MSE40bUYfBeuKLfsMeta } from "/app/modules/sales/pages/sales/returns/create.vue?macro=true";
import { default as _91id_93qGJHezOynyKa_45z4h9T79nLwDLkpL2B9Cu41PgrKdvQAMeta } from "/app/modules/users/pages/users/customers/[id].vue?macro=true";
import { default as editPsxyVskzhgA20HEjbOC24Q6SCktCuzy0Y_45OWaWOyOeYMeta } from "/app/pages/admin/plans/[id]/edit.vue?macro=true";
import { default as edit0yZJLZF33SilPH6_758pjNEviAnTVxeZ3E23jqYqAd4Meta } from "/app/pages/admin/users/[id]/edit.vue?macro=true";
import { default as _91resource_93XT4uaZbC8tP5_qAnpvqHX7_45ZlN8jp8eny1izYjnxxXwMeta } from "/app/modules/hrm/pages/hrm/assets/[resource].vue?macro=true";
import { default as indexIaI5nyqaraz5uZdCff8Ijj3VeHurl_45PBzT2UsI5tKc4Meta } from "/app/modules/hrm/pages/hrm/performance/index.vue?macro=true";
import { default as settingsGMUdgFafFyFYf0KhkJRzGGtu5SwuoOKuii4q915OO_458Meta } from "/app/modules/online-store/pages/online-store/settings.vue?macro=true";
import { default as indexQgAYAkE_PIAogyDkaYviPsm_45Q1vqLuAzrz8_qsqvPHIMeta } from "/app/modules/products/pages/products/brands/index.vue?macro=true";
import { default as out_45of_45stockBJJFIrgBWV45WNchiZ1D49fwTEnUEvlpXOCXD3qKNfMMeta } from "/app/modules/products/pages/products/out-of-stock.vue?macro=true";
import { default as best_45customerd1arRbaMc4sxRPYnOn7IJPfp6HeoAgFqN0P7JAPjQm8Meta } from "/app/modules/reports/pages/reports/best-customer.vue?macro=true";
import { default as _91id_938HDqruxIuNhYYMReTPx4GuP0EL6EguV2ZxObtuegyQkMeta } from "/app/modules/reports/pages/reports/customer/[id].vue?macro=true";
import { default as indextSE14DbVWp627m5qoCT9RdrJ0eog3UTdeLHKDRNRujIMeta } from "/app/modules/users/pages/users/customers/index.vue?macro=true";
import { default as indexJ10s0v5sATzaiFqBO3ighRaWWddHLbSAH6INgc_45vfocMeta } from "/app/modules/users/pages/users/suppliers/index.vue?macro=true";
import { default as bank_45accounts5v8iPSifepnO2lsXkYV_ntUJq1TQjWsbRIiTW4iWPqIMeta } from "/app/modules/accounts/pages/accounts/bank-accounts.vue?macro=true";
import { default as index1ncK_19DsJPde2SH84EGKpWT1JDcS3n_45CKcfhZAC_45_45oMeta } from "/app/modules/accounts/pages/accounts/reports/index.vue?macro=true";
import { default as trial_45balanceK6XTnXxCXA_QaVHhvHCeCjerlCRmXV6HcwP92id7uzMMeta } from "/app/modules/accounts/pages/accounts/trial-balance.vue?macro=true";
import { default as dashboardLvpNV0xlaNSG_456ertVZxfIlDAQqEDeexmlwtoZt58sEMeta } from "/app/modules/headquarters/pages/headquarters/dashboard.vue?macro=true";
import { default as applicationsgYF3euljKxGQ_Tb5rk_8O5_D0veqd2iVh7AQRV90UDkMeta } from "/app/modules/hrm/pages/hrm/leave/applications.vue?macro=true";
import { default as _91_46_46_46slug_93_45TTpJWGijAiYC9IM0oakBeBx4CwSsKZ266SiAeD9vLgMeta } from "/app/modules/hrm/pages/hrm/training/[...slug].vue?macro=true";
import { default as _91id_937flvKAPnbQ8moLGuOELYWjwW0_45xGaUQNCerlyp_45e_45cQMeta } from "/app/modules/products/pages/products/settings/[id].vue?macro=true";
import { default as _91id_93WHtbA7JPjuJtNGxVuPvYOS9P3vNwWy8LYiDsihj9qIoMeta } from "/app/modules/purchase/pages/purchases/returns/[id].vue?macro=true";
import { default as indexXalBwlxvX9Q7WqLlhFU7oxDJWtdB9xbO1EBnsx_45dS0AMeta } from "/app/modules/reports/pages/reports/customer/index.vue?macro=true";
import { default as indexZJSGZOMIJKpUSusGUUtDdrK_459IhnNC8kw6yabYW6eskMeta } from "/app/modules/reports/pages/reports/register/index.vue?macro=true";
import { default as _91id_932m24SRFGBfryPCDVkA_Jp7TYo0Z1e8zF1S2de0BiOaoMeta } from "/app/modules/reports/pages/reports/suppliers/[id].vue?macro=true";
import { default as create9MtNeIHVGL0QuCN5zLAkaChk7Btm5C7l4EZ4166c5LEMeta } from "/app/modules/users/pages/users/customers/create.vue?macro=true";
import { default as createBCVuDNHUMNtT_45PXmmoT9iNCXW90P2fORAW9EDsiMqL4Meta } from "/app/modules/users/pages/users/suppliers/create.vue?macro=true";
import { default as _91resource_93Vr0C7d1JDflNFHDRVKyj0PvcLDkPfIk1sfkW6efhs6AMeta } from "/app/modules/hrm/pages/hrm/meetings/[resource].vue?macro=true";
import { default as _91resource_939FnqgLpbV4Jv_5Ud4P_45QjlVvgC49yci0xSOxm4Xkq2cMeta } from "/app/modules/hrm/pages/hrm/training/[resource].vue?macro=true";
import { default as indexEFEVGCDXCKCWpYd0HYjpTMpt_455TyX9ol77EC55CQWU0Meta } from "/app/modules/products/pages/products/settings/index.vue?macro=true";
import { default as indexkVJziLLcX5QTQycsQDOfoGK_rKrf4Cz7HrcsGiE_459TcMeta } from "/app/modules/purchase/pages/purchases/returns/index.vue?macro=true";
import { default as indexfaGas_45BjJU8hsWjcwI278l3J_457Q8_45fknxJ7ua99YgicMeta } from "/app/modules/reports/pages/reports/suppliers/index.vue?macro=true";
import { default as indexK4NZC0L7x5V_yvOizKpIARlzR7k2gwwc9Y_45PbtTMbgoMeta } from "/app/modules/reports/pages/reports/warehouse/index.vue?macro=true";
import { default as journal_45entrieswCc9i3xiTehMZNpsa_EwVcN3FiQCQOmm_lHXulZWEP0Meta } from "/app/modules/accounts/pages/accounts/journal-entries.vue?macro=true";
import { default as bulk_45messagingtiePUMDuTONZXXFmCtyR6oVE4xTXuCkmbDkelD_45jf9gMeta } from "/app/modules/marketing/pages/marketing/bulk-messaging.vue?macro=true";
import { default as _91id_93gGncUgJC_45Q_45zq6jdSP07BKO6lUAE3KVHp0CDVPwmDzcMeta } from "/app/modules/products/pages/products/categories/[id].vue?macro=true";
import { default as _91type_93ofHlye8rs2U_KteKTh7IhIC718YK3buEz5VLjRmYtxYMeta } from "/app/modules/products/pages/products/metadata/[type].vue?macro=true";
import { default as create_5ZApI6JNYxVeZTZ2KUgIWII8XaguoJDno1q2hh94H8Meta } from "/app/modules/products/pages/products/settings/create.vue?macro=true";
import { default as createWqOr8QHLZ_74nXC4vLPjSIVVAGj9f1RZ8wnBK4CIG6MMeta } from "/app/modules/purchase/pages/purchases/returns/create.vue?macro=true";
import { default as product_45quantityuM74Eg4_45NCq6PgowEy7kx9R_15KL1_VTLBDtpNMtCyUMeta } from "/app/modules/reports/pages/reports/product-quantity.vue?macro=true";
import { default as indexyAauDIooSYRPrq_jQoVSqo5gku4w8ls2g85vs0LPfsEMeta } from "/app/modules/expenses/pages/expenses/categories/index.vue?macro=true";
import { default as _91_46_46_46slug_93aaSJZCmM5q0f6jrYKXa5sv0v5JgFcwfN_45LScMMTTHRgMeta } from "/app/modules/hrm/pages/hrm/performance/[...slug].vue?macro=true";
import { default as indexzbm_chM_1G02_4h_45MGXq6m73w9mFIXBovreamIiPgk0Meta } from "/app/modules/marketing/pages/marketing/campaigns/index.vue?macro=true";
import { default as indexUB4txVsBOTUWAVtAoa5sYuNxJFQ_45S8sRaXLCr_rEECQMeta } from "/app/modules/products/pages/products/base-units/index.vue?macro=true";
import { default as indexJnxVteib6wROWLmaDWSIxPZrbBTVbz__45Vih1HlT0yR0Meta } from "/app/modules/products/pages/products/categories/index.vue?macro=true";
import { default as indexYwJFJgjumEfMo2_45B3zAV7itOAdeReuazw9i2mo1h5MwMeta } from "/app/modules/products/pages/products/quotations/index.vue?macro=true";
import { default as indexz9a5MN27_451VvOspCBl9ppSnXeMDHKQ8XaC3FSKMMeFIMeta } from "/app/modules/products/pages/products/variations/index.vue?macro=true";
import { default as indexJ1B_459Jj1rRrn73e4TfwIxZLa3j70LHB2uq67Ohk8bAoMeta } from "/app/modules/reports/pages/reports/ai-insights/index.vue?macro=true";
import { default as chart_45of_45accountsNYMo3tiN2JrOgElaLQOA3jJVhbxu6TPBsmA2nUqvZr8Meta } from "/app/modules/accounts/pages/accounts/chart-of-accounts.vue?macro=true";
import { default as cash_45flowYBjiaIEbILUJJITp583vzgSl1hNy3lrrIc_45qMPEZ4DMMeta } from "/app/modules/accounts/pages/accounts/reports/cash-flow.vue?macro=true";
import { default as _91resource_93h80Pasfk_458B7nOSkqK3vxAaK1oyoUp1EbNRoSUbQogIMeta } from "/app/modules/hrm/pages/hrm/performance/[resource].vue?macro=true";
import { default as _91resource_93vEAKIID7hwVWGpWp8gvDzkFcbUzdktlQujbDq10r_EoMeta } from "/app/modules/hrm/pages/hrm/recruitment/[resource].vue?macro=true";
import { default as candidateswhJ3u4kNKoMKnkFMh6FE4eSjvI2nb4ZanWrX83sB2AMMeta } from "/app/modules/hrm/pages/hrm/recruitment/candidates.vue?macro=true";
import { default as interviewsA4Lo_Jek6bM20VkoWk9I3kYITbSeWd6_45dAE2l9dnfsQMeta } from "/app/modules/hrm/pages/hrm/recruitment/interviews.vue?macro=true";
import { default as createKSnoP3sFvlMAmmNmmnd_4539oGnZ4mUYs_YA9iLr75YrsMeta } from "/app/modules/marketing/pages/marketing/campaigns/create.vue?macro=true";
import { default as indexlOycZPPEFdCslsadzRDxB9tqMAfxXvsITGiG7G2uy_8Meta } from "/app/modules/products/pages/products/adjustments/index.vue?macro=true";
import { default as createwXRw440fwJmpf1M7QvXgepbyRF9qhBM_LS3Z2VzaWPgMeta } from "/app/modules/products/pages/products/quotations/create.vue?macro=true";
import { default as edit_45fitz3drrCmFTyKL_45ONxN3jZIH1LY_1wpATfgynmbHfH0VIMeta } from "/app/modules/products/pages/products/settings/edit-fit.vue?macro=true";
import { default as view_45fitdbMgJ7dRfY6YR24D1hB8iPBAFyDAqaKG8dmP_TkDK5AMeta } from "/app/modules/products/pages/products/settings/view-fit.vue?macro=true";
import { default as index22iqlDua5cG3WDgAUR1XaP_45HhLbBc42yJsP2S9YyAacMeta } from "/app/modules/online-store/pages/online-store/products/index.vue?macro=true";
import { default as creatext83WZKr5Kw48y_45YhzvcWlOp1KKzblNehzhCM8BepYMMeta } from "/app/modules/products/pages/products/adjustments/create.vue?macro=true";
import { default as strengthsN_45td8l0Ro7cLBG_D_i_454fVUvNPuQuHC0q8uUY_oHDv4Meta } from "/app/modules/products/pages/products/pharmacy/strengths.vue?macro=true";
import { default as profit_45lossOqTZJ_vgN7AenmCbmRxavE47eoSUa_45ekfCfffiMGd_EMeta } from "/app/modules/accounts/pages/accounts/reports/profit-loss.vue?macro=true";
import { default as job_45postingsHKIMCJdxBXFYj7pu0Q57IQayy_UcBOYUM_jNC9Xwy_8Meta } from "/app/modules/hrm/pages/hrm/recruitment/job-postings.vue?macro=true";
import { default as indexft5xiqSVPOpnlHhm5Xq9c8FjAsMaw3xqqI0b6gxTJIkMeta } from "/app/modules/products/pages/products/print-barcode/index.vue?macro=true";
import { default as top_45selling_45productsQy6KJBXV_45l30jR47g0eDb5_ZChaaT9c9_xcXRWPGEO0Meta } from "/app/modules/reports/pages/reports/top-selling-products.vue?macro=true";
import { default as balance_45sheetQrM8VRAkscptRrokrK0gAEpC_45_UmTgSRzAuKNYIPahUMeta } from "/app/modules/accounts/pages/accounts/reports/balance-sheet.vue?macro=true";
import { default as time_45entriesFVyw8X9DjGBw5G0E8Qy6MWB8GJ1jK9VmslKPTkonod8Meta } from "/app/modules/hrm/pages/hrm/time-tracking/time-entries.vue?macro=true";
import { default as dosage_45formsbChoHxEqTpG_SsCthHm9fO0KrvoRE_xF1lOVne4EsXgMeta } from "/app/modules/products/pages/products/pharmacy/dosage-forms.vue?macro=true";
import { default as indexk3_vOX54caa25OTvWUfb1tdvn6K0PDL3ByY3mvCNkAMMeta } from "/app/modules/reports/pages/reports/profit-maximizer/index.vue?macro=true";
import { default as generic_45namesDsawJjcdmWKhEIDJtQCDgTYQaO9tpG9kMMkQ2OjBdUQMeta } from "/app/modules/products/pages/products/pharmacy/generic-names.vue?macro=true";
import { default as manufacturersuW1Ret9LGteyv_KRbpUqfI762e2hPpQ_BAIVvhBRLLEMeta } from "/app/modules/products/pages/products/pharmacy/manufacturers.vue?macro=true";
import { default as _91resource_93nVsWf2UStXkgyLAcutnG0YlYFE1ybOggA5ZJzxHKW4oMeta } from "/app/modules/hrm/pages/hrm/contract-management/[resource].vue?macro=true";
import { default as _91resource_93QKjMW0p1ShRHXjT2g_45DGwUNyEoXV7yNLHa6ZnHaJvvUMeta } from "/app/modules/hrm/pages/hrm/document-management/[resource].vue?macro=true";
import { default as storage_45conditionsE1l0p8uYxPPlsIDbxTnCLbwBiK1kubr43HWoEJNlcKAMeta } from "/app/modules/products/pages/products/pharmacy/storage-conditions.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/modules/dashboard/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "roles",
    path: "/roles",
    meta: rolesASFo9P3Rgf6vBvUT16SL7_51yonITdf2p4ubFWv2ycYMeta || {},
    component: () => import("/app/pages/roles.vue")
  },
  {
    name: "crm-id",
    path: "/crm/:id()",
    meta: _91id_93WakUUi_453DQQ2BIADVSHKTBr7I0hoj1jZv6o6dBrK7ykMeta || {},
    component: () => import("/app/modules/crm/pages/crm/[id].vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "acl",
    path: "/acl",
    component: () => import("/app/modules/acl/pages/acl/index.vue")
  },
  {
    name: "admin-cms",
    path: "/admin/cms",
    component: () => import("/app/pages/admin/cms.vue")
  },
  {
    name: "crm",
    path: "/crm",
    meta: indexgFc3XCj6BHaZDPvZAXMUTnIODIyIsqDKpzxAc0YoxIAMeta || {},
    component: () => import("/app/modules/crm/pages/crm/index.vue")
  },
  {
    name: "hrm",
    path: "/hrm",
    meta: indexrR_SEkare_45AM9Tgp_PCaUILQx0avTztbKm94zfTUzBgMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/index.vue")
  },
  {
    name: "hrm-media",
    path: "/hrm/media",
    meta: mediahpbreO2XnTr_45BpFIFHIKzYdEzn7l24rhqX2IfBy7ZEIMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/media.vue")
  },
  {
    name: "pos",
    path: "/pos",
    meta: indexBfzup7ozt912qrHTa1aaC5eGV6nQWXCzI1RQdW4oyP4Meta || {},
    component: () => import("/app/modules/pos/pages/pos/index.vue")
  },
  {
    name: "acl-create",
    path: "/acl/create",
    component: () => import("/app/modules/acl/pages/acl/create.vue")
  },
  {
    name: "activation",
    path: "/activation",
    component: () => import("/app/modules/license/pages/activation.vue")
  },
  {
    name: "hrm-leaves",
    path: "/hrm/leaves",
    component: () => import("/app/modules/hrm/pages/hrm/leaves.vue")
  },
  {
    name: "sales-id",
    path: "/sales/:id()",
    component: () => import("/app/modules/sales/pages/sales/[id].vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/app/modules/users/pages/users/[id].vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "hrm-payroll",
    path: "/hrm/payroll",
    meta: payrollRTIkFBVglb4iZmP6Gooi1HaxlObC7xcfISWhtPrDbIkMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/payroll.vue"),
    children: [
  {
    name: "hrm-payroll-payslips",
    path: "payslips",
    meta: payslips9AIBoFUSEBKqKQFEE7I5GIgGEWoP6Uk4Ls6JyDWCHgIMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/payroll/payslips.vue")
  },
  {
    name: "hrm-payroll-payroll-runs",
    path: "payroll-runs",
    meta: payroll_45runscnf5sD2gPajgr1hYSPa3CyqPzT_45omxa1sQ8e6ZJZILcMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/payroll/payroll-runs.vue")
  },
  {
    name: "hrm-payroll-employee-salaries",
    path: "employee-salaries",
    meta: employee_45salariesWUYgSA3kJFbd6uhLiHOkHH5VH8JLp2Iz1O71HORsT0EMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/payroll/employee-salaries.vue")
  },
  {
    name: "hrm-payroll-salary-components",
    path: "salary-components",
    meta: salary_45components_IawvmLUXeSshiuefXJrMSceVvH7cCJGJfQa1NcRWLwMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/payroll/salary-components.vue")
  }
]
  },
  {
    name: "permissions",
    path: "/permissions",
    component: () => import("/app/pages/permissions.vue")
  },
  {
    name: "sales",
    path: "/sales",
    component: () => import("/app/modules/sales/pages/sales/index.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: index3DbT5RW8O7wxIyGp2_9jh_oPsOlH8_454KXTIJ1xcdurwMeta || {},
    component: () => import("/app/modules/users/pages/users/index.vue")
  },
  {
    name: branchesvyUjVP_z67OcAINM5_45fakidif8HhATngrZ_45LLk1xeiIMeta?.name,
    path: "/hrm/branches",
    meta: branchesvyUjVP_z67OcAINM5_45fakidif8HhATngrZ_45LLk1xeiIMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/branches.vue"),
    children: [
  {
    name: "hrm-branches",
    path: "",
    meta: indexFqSpGuue51kjflzjuxVSEs_45C4bxHvcNT37vXlhHtiT4Meta || {},
    component: () => import("/app/modules/hrm/pages/hrm/branches/index.vue")
  }
]
  },
  {
    name: "hrm-calendar",
    path: "/hrm/calendar",
    meta: calendarSIydakh2zAkbblJGLIQ4FD0KiywiRV9ExZiwT7EwSY4Meta || {},
    component: () => import("/app/modules/hrm/pages/hrm/calendar.vue")
  },
  {
    name: "hrm-holidays",
    path: "/hrm/holidays",
    meta: holidaysin0Doy5PcM_TZjJE4vlAfy89Ic0h_45FhGFFIGQBQ5mxgMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/holidays.vue")
  },
  {
    name: "hrm-settings",
    path: "/hrm/settings",
    meta: settingsa49NA_o6MUHRZoQSDY5tnyax_R00LRtZxEeBQLIX_tQMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/settings.vue")
  },
  {
    name: "sales-create",
    path: "/sales/create",
    component: () => import("/app/modules/sales/pages/sales/create.vue")
  },
  {
    name: "users-create",
    path: "/users/create",
    component: () => import("/app/modules/users/pages/users/create.vue")
  },
  {
    name: "acl-edit-id",
    path: "/acl/edit/:id()",
    component: () => import("/app/modules/acl/pages/acl/edit/[id].vue")
  },
  {
    name: "hrm-slug",
    path: "/hrm/:slug(.*)*",
    component: () => import("/app/modules/hrm/pages/hrm/[...slug].vue")
  },
  {
    name: "hrm-biometric",
    path: "/hrm/biometric",
    meta: biometricsiLYqyLJZl6d_45mOVX3TKbdXTTD9uRu4T1UH_cUpUX8AMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/biometric.vue")
  },
  {
    name: "loyalty",
    path: "/loyalty",
    component: () => import("/app/modules/loyalty/pages/loyalty/index.vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/app/modules/products/pages/products/[id].vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/app/modules/reports/pages/reports/index.vue")
  },
  {
    name: "reports-sales",
    path: "/reports/sales",
    component: () => import("/app/modules/reports/pages/reports/sales.vue")
  },
  {
    name: "accounts",
    path: "/accounts",
    component: () => import("/app/modules/accounts/pages/accounts/index.vue")
  },
  {
    name: "admin-payments",
    path: "/admin/payments",
    component: () => import("/app/pages/admin/payments.vue")
  },
  {
    name: "business",
    path: "/business",
    component: () => import("/app/modules/business/pages/business/index.vue")
  },
  {
    name: "expenses",
    path: "/expenses",
    meta: indexbQIS1Nkd1Bc05tQiDZ2C28O1H7bgqu64bYThQl_KTo8Meta || {},
    component: () => import("/app/modules/expenses/pages/expenses/index.vue")
  },
  {
    name: "hrm-resource",
    path: "/hrm/:resource()",
    meta: _91resource_93BcyQ6zTJuZ8_eCAOzRuqIaEcS0S1DXYqe80l9DU8VF0Meta || {},
    component: () => import("/app/modules/hrm/pages/hrm/[resource].vue")
  },
  {
    name: "hrm-attendance",
    path: "/hrm/attendance",
    meta: attendance7_9yZF6J1jRq0_45RpN29rHmrwq4exK587lkMrvjvQ_zsMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/attendance.vue")
  },
  {
    name: "products",
    path: "/products",
    meta: indexvZo1JHvPox3IVt1eN_In_45X7zcDuqKzsNklF1aGyGbBMMeta || {},
    component: () => import("/app/modules/products/pages/products/index.vue")
  },
  {
    name: "purchases-id",
    path: "/purchases/:id()",
    component: () => import("/app/modules/purchase/pages/purchases/[id].vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/app/modules/settings/pages/settings/index.vue")
  },
  {
    name: "setup-business",
    path: "/setup-business",
    meta: setup_45businessXAb_45EmVnanlKFQXZ6P5ZhsYFE6QHXOpbbS_7PCUMBZQMeta || {},
    component: () => import("/app/pages/setup-business.vue")
  },
  {
    name: "transfers-id",
    path: "/transfers/:id()",
    component: () => import("/app/modules/transfers/pages/transfers/[id].vue")
  },
  {
    name: "whatsapp",
    path: "/whatsapp",
    meta: index7k5RtnDifftRpA_f70jEQL4EOQ3gGaYEQykls4yOoikMeta || {},
    component: () => import("/app/modules/whatsapp/pages/whatsapp/index.vue")
  },
  {
    name: "accounts-ledger",
    path: "/accounts/ledger",
    component: () => import("/app/modules/accounts/pages/accounts/ledger.vue")
  },
  {
    name: "admin-inquiries",
    path: "/admin/inquiries",
    component: () => import("/app/pages/admin/inquiries.vue")
  },
  {
    name: "expenses-create",
    path: "/expenses/create",
    meta: createzbpaj_45hsiPJGtK_PJswrgiopS3o0C32iu0Ur2Sx8i0sMeta || {},
    component: () => import("/app/modules/expenses/pages/expenses/create.vue")
  },
  {
    name: departmentsyqKZb74chvNbfWXMsShsc3MLVZmFJtq6DA_puSJsxjAMeta?.name,
    path: "/hrm/departments",
    meta: departmentsyqKZb74chvNbfWXMsShsc3MLVZmFJtq6DA_puSJsxjAMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/departments.vue"),
    children: [
  {
    name: "hrm-departments",
    path: "",
    meta: indexWto_45dQaB0HPYvPKcR0ERaClHo2BCSooqihyA7KSccsoMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/departments/index.vue")
  }
]
  },
  {
    name: "hrm-leave-types",
    path: "/hrm/leave/types",
    meta: types17Ne9GWVTsJ4IjWyYQIPyzO5af6T0LrmzRaKholqI3cMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/leave/types.vue")
  },
  {
    name: "products-create",
    path: "/products/create",
    meta: createNR5wcTGqn9draBW4uYN2fKAdEqo5YadEWmXUpLpasG0Meta || {},
    component: () => import("/app/modules/products/pages/products/create.vue")
  },
  {
    name: "purchases",
    path: "/purchases",
    component: () => import("/app/modules/purchase/pages/purchases/index.vue")
  },
  {
    name: "transfers",
    path: "/transfers",
    component: () => import("/app/modules/transfers/pages/transfers/index.vue")
  },
  {
    name: "warehouse",
    path: "/warehouse",
    component: () => import("/app/modules/warehouse/pages/warehouse/index.vue")
  },
  {
    name: "accounts-banking",
    path: "/accounts/banking",
    component: () => import("/app/modules/accounts/pages/accounts/banking.vue")
  },
  {
    name: "admin-currencies",
    path: "/admin/currencies",
    component: () => import("/app/pages/admin/currencies.vue")
  },
  {
    name: "hrm-assets",
    path: "/hrm/assets",
    component: () => import("/app/modules/hrm/pages/hrm/assets/index.vue")
  },
  {
    name: designationsRp9cav86BzvGPJtl4zTIlSln5gvnD7D82c__45ae_4F6IMeta?.name,
    path: "/hrm/designations",
    meta: designationsRp9cav86BzvGPJtl4zTIlSln5gvnD7D82c__45ae_4F6IMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/designations.vue"),
    children: [
  {
    name: "hrm-designations",
    path: "",
    meta: indexGbdchlrChgxoAQqyXgpAzFyGl2vqJ4e5IY0qZZi0VBoMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/designations/index.vue")
  }
]
  },
  {
    name: "hrm-landing-page",
    path: "/hrm/landing-page",
    meta: landing_45page6ke7IZP7kPikiqhnF0_RFYfhkPRg2xBzcuWnVjaRf4MMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/landing-page.vue")
  },
  {
    name: "purchases-create",
    path: "/purchases/create",
    component: () => import("/app/modules/purchase/pages/purchases/create.vue")
  },
  {
    name: "reports-purchase",
    path: "/reports/purchase",
    component: () => import("/app/modules/reports/pages/reports/purchase.vue")
  },
  {
    name: "transfers-create",
    path: "/transfers/create",
    component: () => import("/app/modules/transfers/pages/transfers/create.vue")
  },
  {
    name: "accounts-vouchers",
    path: "/accounts/vouchers",
    component: () => import("/app/modules/accounts/pages/accounts/vouchers.vue")
  },
  {
    name: "admin-plans",
    path: "/admin/plans",
    component: () => import("/app/pages/admin/plans/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/app/pages/admin/users/index.vue")
  },
  {
    name: "hrm-meetings-list",
    path: "/hrm/meetings/list",
    meta: listfpw6G0aq11V8OVxA1OhIvtVHpE3_45rqfz38kjVLOY2O4Meta || {},
    component: () => import("/app/modules/hrm/pages/hrm/meetings/list.vue")
  },
  {
    name: "admin-plans-create",
    path: "/admin/plans/create",
    component: () => import("/app/pages/admin/plans/create.vue")
  },
  {
    name: "admin-transactions",
    path: "/admin/transactions",
    component: () => import("/app/pages/admin/transactions.vue")
  },
  {
    name: "admin-users-create",
    path: "/admin/users/create",
    component: () => import("/app/pages/admin/users/create.vue")
  },
  {
    name: "expenses-edit-id",
    path: "/expenses/edit/:id()",
    meta: _91id_93sAVzEtupnVvhfsZVEA6DHb2VYHr5bGPbFEkh3JAG1jMMeta || {},
    component: () => import("/app/modules/expenses/pages/expenses/edit/[id].vue")
  },
  {
    name: "hrm-employees-id",
    path: "/hrm/employees/:id()",
    meta: _91id_93rtT99T1_WWp8p8dRJNsBW9c4A_m8ffFhL_45zimWvPq14Meta || {},
    component: () => import("/app/modules/hrm/pages/hrm/employees/[id].vue")
  },
  {
    name: "hrm-leave-balances",
    path: "/hrm/leave/balances",
    meta: balanceszWMG_7up3QdweXKxBNLKHxBcoR5oCXaj__55m4DCoEoMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/leave/balances.vue")
  },
  {
    name: "hrm-leave-policies",
    path: "/hrm/leave/policies",
    meta: policiesYmbckDSim6FCeWtjeARqv7u3qPg85QakvecBEB_DGlAMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/leave/policies.vue")
  },
  {
    name: "hrm-training",
    path: "/hrm/training",
    component: () => import("/app/modules/hrm/pages/hrm/training/index.vue")
  },
  {
    name: "products-low-stock",
    path: "/products/low-stock",
    component: () => import("/app/modules/products/pages/products/low-stock.vue")
  },
  {
    name: "reports-stock-id",
    path: "/reports/stock/:id()",
    component: () => import("/app/modules/reports/pages/reports/stock/[id].vue")
  },
  {
    name: "sales-customer-due",
    path: "/sales/customer-due",
    component: () => import("/app/modules/sales/pages/sales/customer-due.vue")
  },
  {
    name: "sales-returns-id",
    path: "/sales/returns/:id()",
    component: () => import("/app/modules/sales/pages/sales/returns/[id].vue")
  },
  {
    name: "accounts-loans-id",
    path: "/accounts/loans/:id()",
    component: () => import("/app/modules/accounts/pages/accounts/loans/[id].vue")
  },
  {
    name: "admin-subscriptions",
    path: "/admin/subscriptions",
    component: () => import("/app/pages/admin/subscriptions.vue")
  },
  {
    name: "hrm-employees",
    path: "/hrm/employees",
    meta: indexQ3tdZS10mF2Ol3ibbvjtN_45KoXJEOaaZHq_45e7Sdg5bTAMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/employees/index.vue")
  },
  {
    name: "reports-profit-loss",
    path: "/reports/profit-loss",
    component: () => import("/app/modules/reports/pages/reports/profit-loss.vue")
  },
  {
    name: "reports-stock",
    path: "/reports/stock",
    component: () => import("/app/modules/reports/pages/reports/stock/index.vue")
  },
  {
    name: "sales-returns",
    path: "/sales/returns",
    component: () => import("/app/modules/sales/pages/sales/returns/index.vue")
  },
  {
    name: "transfers-edit-id",
    path: "/transfers/edit/:id()",
    component: () => import("/app/modules/transfers/pages/transfers/edit/[id].vue")
  },
  {
    name: "accounts-loans",
    path: "/accounts/loans",
    component: () => import("/app/modules/accounts/pages/accounts/loans/index.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    component: () => import("/app/pages/admin/settings/index.vue")
  },
  {
    name: "hrm-assets-slug",
    path: "/hrm/assets/:slug(.*)*",
    component: () => import("/app/modules/hrm/pages/hrm/assets/[...slug].vue")
  },
  {
    name: "hrm-employees-create",
    path: "/hrm/employees/create",
    meta: createTdlO7GcvVNU4BKOdZfV3nvf_d8pfydv238GKgJIJiZEMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/employees/create.vue")
  },
  {
    name: "hrm-plans-resource",
    path: "/hrm/plans/:resource()",
    meta: _91resource_93RBRxiDhGqNIk4YNHceSGQcztQheBXXjt6d0XRrJhoMwMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/plans/[resource].vue")
  },
  {
    name: "products-units",
    path: "/products/units",
    component: () => import("/app/modules/products/pages/products/units/index.vue")
  },
  {
    name: "sales-returns-create",
    path: "/sales/returns/create",
    component: () => import("/app/modules/sales/pages/sales/returns/create.vue")
  },
  {
    name: "users-customers-id",
    path: "/users/customers/:id()",
    component: () => import("/app/modules/users/pages/users/customers/[id].vue")
  },
  {
    name: "admin-plans-id-edit",
    path: "/admin/plans/:id()/edit",
    component: () => import("/app/pages/admin/plans/[id]/edit.vue")
  },
  {
    name: "admin-users-id-edit",
    path: "/admin/users/:id()/edit",
    component: () => import("/app/pages/admin/users/[id]/edit.vue")
  },
  {
    name: "hrm-assets-resource",
    path: "/hrm/assets/:resource()",
    meta: _91resource_93XT4uaZbC8tP5_qAnpvqHX7_45ZlN8jp8eny1izYjnxxXwMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/assets/[resource].vue")
  },
  {
    name: "hrm-performance",
    path: "/hrm/performance",
    component: () => import("/app/modules/hrm/pages/hrm/performance/index.vue")
  },
  {
    name: "online-store-settings",
    path: "/online-store/settings",
    component: () => import("/app/modules/online-store/pages/online-store/settings.vue")
  },
  {
    name: "products-brands",
    path: "/products/brands",
    component: () => import("/app/modules/products/pages/products/brands/index.vue")
  },
  {
    name: "products-out-of-stock",
    path: "/products/out-of-stock",
    component: () => import("/app/modules/products/pages/products/out-of-stock.vue")
  },
  {
    name: "reports-best-customer",
    path: "/reports/best-customer",
    component: () => import("/app/modules/reports/pages/reports/best-customer.vue")
  },
  {
    name: "reports-customer-id",
    path: "/reports/customer/:id()",
    component: () => import("/app/modules/reports/pages/reports/customer/[id].vue")
  },
  {
    name: "users-customers",
    path: "/users/customers",
    component: () => import("/app/modules/users/pages/users/customers/index.vue")
  },
  {
    name: "users-suppliers",
    path: "/users/suppliers",
    component: () => import("/app/modules/users/pages/users/suppliers/index.vue")
  },
  {
    name: "accounts-bank-accounts",
    path: "/accounts/bank-accounts",
    component: () => import("/app/modules/accounts/pages/accounts/bank-accounts.vue")
  },
  {
    name: "accounts-reports",
    path: "/accounts/reports",
    component: () => import("/app/modules/accounts/pages/accounts/reports/index.vue")
  },
  {
    name: "accounts-trial-balance",
    path: "/accounts/trial-balance",
    component: () => import("/app/modules/accounts/pages/accounts/trial-balance.vue")
  },
  {
    name: "headquarters-dashboard",
    path: "/headquarters/dashboard",
    component: () => import("/app/modules/headquarters/pages/headquarters/dashboard.vue")
  },
  {
    name: "hrm-leave-applications",
    path: "/hrm/leave/applications",
    meta: applicationsgYF3euljKxGQ_Tb5rk_8O5_D0veqd2iVh7AQRV90UDkMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/leave/applications.vue")
  },
  {
    name: "hrm-training-slug",
    path: "/hrm/training/:slug(.*)*",
    component: () => import("/app/modules/hrm/pages/hrm/training/[...slug].vue")
  },
  {
    name: "products-settings-id",
    path: "/products/settings/:id()",
    component: () => import("/app/modules/products/pages/products/settings/[id].vue")
  },
  {
    name: "purchases-returns-id",
    path: "/purchases/returns/:id()",
    component: () => import("/app/modules/purchase/pages/purchases/returns/[id].vue")
  },
  {
    name: "reports-customer",
    path: "/reports/customer",
    component: () => import("/app/modules/reports/pages/reports/customer/index.vue")
  },
  {
    name: "reports-register",
    path: "/reports/register",
    component: () => import("/app/modules/reports/pages/reports/register/index.vue")
  },
  {
    name: "reports-suppliers-id",
    path: "/reports/suppliers/:id()",
    component: () => import("/app/modules/reports/pages/reports/suppliers/[id].vue")
  },
  {
    name: "users-customers-create",
    path: "/users/customers/create",
    component: () => import("/app/modules/users/pages/users/customers/create.vue")
  },
  {
    name: "users-suppliers-create",
    path: "/users/suppliers/create",
    component: () => import("/app/modules/users/pages/users/suppliers/create.vue")
  },
  {
    name: "hrm-meetings-resource",
    path: "/hrm/meetings/:resource()",
    meta: _91resource_93Vr0C7d1JDflNFHDRVKyj0PvcLDkPfIk1sfkW6efhs6AMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/meetings/[resource].vue")
  },
  {
    name: "hrm-training-resource",
    path: "/hrm/training/:resource()",
    meta: _91resource_939FnqgLpbV4Jv_5Ud4P_45QjlVvgC49yci0xSOxm4Xkq2cMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/training/[resource].vue")
  },
  {
    name: "products-settings",
    path: "/products/settings",
    component: () => import("/app/modules/products/pages/products/settings/index.vue")
  },
  {
    name: "purchases-returns",
    path: "/purchases/returns",
    component: () => import("/app/modules/purchase/pages/purchases/returns/index.vue")
  },
  {
    name: "reports-suppliers",
    path: "/reports/suppliers",
    component: () => import("/app/modules/reports/pages/reports/suppliers/index.vue")
  },
  {
    name: "reports-warehouse",
    path: "/reports/warehouse",
    meta: indexK4NZC0L7x5V_yvOizKpIARlzR7k2gwwc9Y_45PbtTMbgoMeta || {},
    component: () => import("/app/modules/reports/pages/reports/warehouse/index.vue")
  },
  {
    name: "accounts-journal-entries",
    path: "/accounts/journal-entries",
    component: () => import("/app/modules/accounts/pages/accounts/journal-entries.vue")
  },
  {
    name: "marketing-bulk-messaging",
    path: "/marketing/bulk-messaging",
    meta: bulk_45messagingtiePUMDuTONZXXFmCtyR6oVE4xTXuCkmbDkelD_45jf9gMeta || {},
    component: () => import("/app/modules/marketing/pages/marketing/bulk-messaging.vue")
  },
  {
    name: "products-categories-id",
    path: "/products/categories/:id()",
    component: () => import("/app/modules/products/pages/products/categories/[id].vue")
  },
  {
    name: "products-metadata-type",
    path: "/products/metadata/:type()",
    component: () => import("/app/modules/products/pages/products/metadata/[type].vue")
  },
  {
    name: "products-settings-create",
    path: "/products/settings/create",
    component: () => import("/app/modules/products/pages/products/settings/create.vue")
  },
  {
    name: "purchases-returns-create",
    path: "/purchases/returns/create",
    component: () => import("/app/modules/purchase/pages/purchases/returns/create.vue")
  },
  {
    name: "reports-product-quantity",
    path: "/reports/product-quantity",
    component: () => import("/app/modules/reports/pages/reports/product-quantity.vue")
  },
  {
    name: "expenses-categories",
    path: "/expenses/categories",
    meta: indexyAauDIooSYRPrq_jQoVSqo5gku4w8ls2g85vs0LPfsEMeta || {},
    component: () => import("/app/modules/expenses/pages/expenses/categories/index.vue")
  },
  {
    name: "hrm-performance-slug",
    path: "/hrm/performance/:slug(.*)*",
    component: () => import("/app/modules/hrm/pages/hrm/performance/[...slug].vue")
  },
  {
    name: "marketing-campaigns",
    path: "/marketing/campaigns",
    component: () => import("/app/modules/marketing/pages/marketing/campaigns/index.vue")
  },
  {
    name: "products-base-units",
    path: "/products/base-units",
    component: () => import("/app/modules/products/pages/products/base-units/index.vue")
  },
  {
    name: "products-categories",
    path: "/products/categories",
    meta: indexJnxVteib6wROWLmaDWSIxPZrbBTVbz__45Vih1HlT0yR0Meta || {},
    component: () => import("/app/modules/products/pages/products/categories/index.vue")
  },
  {
    name: "products-quotations",
    path: "/products/quotations",
    component: () => import("/app/modules/products/pages/products/quotations/index.vue")
  },
  {
    name: "products-variations",
    path: "/products/variations",
    component: () => import("/app/modules/products/pages/products/variations/index.vue")
  },
  {
    name: "reports-ai-insights",
    path: "/reports/ai-insights",
    component: () => import("/app/modules/reports/pages/reports/ai-insights/index.vue")
  },
  {
    name: "accounts-chart-of-accounts",
    path: "/accounts/chart-of-accounts",
    component: () => import("/app/modules/accounts/pages/accounts/chart-of-accounts.vue")
  },
  {
    name: "accounts-reports-cash-flow",
    path: "/accounts/reports/cash-flow",
    component: () => import("/app/modules/accounts/pages/accounts/reports/cash-flow.vue")
  },
  {
    name: "hrm-performance-resource",
    path: "/hrm/performance/:resource()",
    meta: _91resource_93h80Pasfk_458B7nOSkqK3vxAaK1oyoUp1EbNRoSUbQogIMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/performance/[resource].vue")
  },
  {
    name: "hrm-recruitment-resource",
    path: "/hrm/recruitment/:resource()",
    meta: _91resource_93vEAKIID7hwVWGpWp8gvDzkFcbUzdktlQujbDq10r_EoMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/recruitment/[resource].vue")
  },
  {
    name: "hrm-recruitment-candidates",
    path: "/hrm/recruitment/candidates",
    meta: candidateswhJ3u4kNKoMKnkFMh6FE4eSjvI2nb4ZanWrX83sB2AMMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/recruitment/candidates.vue")
  },
  {
    name: "hrm-recruitment-interviews",
    path: "/hrm/recruitment/interviews",
    meta: interviewsA4Lo_Jek6bM20VkoWk9I3kYITbSeWd6_45dAE2l9dnfsQMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/recruitment/interviews.vue")
  },
  {
    name: "marketing-campaigns-create",
    path: "/marketing/campaigns/create",
    component: () => import("/app/modules/marketing/pages/marketing/campaigns/create.vue")
  },
  {
    name: "products-adjustments",
    path: "/products/adjustments",
    component: () => import("/app/modules/products/pages/products/adjustments/index.vue")
  },
  {
    name: "products-quotations-create",
    path: "/products/quotations/create",
    component: () => import("/app/modules/products/pages/products/quotations/create.vue")
  },
  {
    name: "products-settings-edit-fit",
    path: "/products/settings/edit-fit",
    component: () => import("/app/modules/products/pages/products/settings/edit-fit.vue")
  },
  {
    name: "products-settings-view-fit",
    path: "/products/settings/view-fit",
    component: () => import("/app/modules/products/pages/products/settings/view-fit.vue")
  },
  {
    name: "online-store-products",
    path: "/online-store/products",
    component: () => import("/app/modules/online-store/pages/online-store/products/index.vue")
  },
  {
    name: "products-adjustments-create",
    path: "/products/adjustments/create",
    component: () => import("/app/modules/products/pages/products/adjustments/create.vue")
  },
  {
    name: "products-pharmacy-strengths",
    path: "/products/pharmacy/strengths",
    component: () => import("/app/modules/products/pages/products/pharmacy/strengths.vue")
  },
  {
    name: "accounts-reports-profit-loss",
    path: "/accounts/reports/profit-loss",
    component: () => import("/app/modules/accounts/pages/accounts/reports/profit-loss.vue")
  },
  {
    name: "hrm-recruitment-job-postings",
    path: "/hrm/recruitment/job-postings",
    meta: job_45postingsHKIMCJdxBXFYj7pu0Q57IQayy_UcBOYUM_jNC9Xwy_8Meta || {},
    component: () => import("/app/modules/hrm/pages/hrm/recruitment/job-postings.vue")
  },
  {
    name: "products-print-barcode",
    path: "/products/print-barcode",
    component: () => import("/app/modules/products/pages/products/print-barcode/index.vue")
  },
  {
    name: "reports-top-selling-products",
    path: "/reports/top-selling-products",
    component: () => import("/app/modules/reports/pages/reports/top-selling-products.vue")
  },
  {
    name: "accounts-reports-balance-sheet",
    path: "/accounts/reports/balance-sheet",
    component: () => import("/app/modules/accounts/pages/accounts/reports/balance-sheet.vue")
  },
  {
    name: "hrm-time-tracking-time-entries",
    path: "/hrm/time-tracking/time-entries",
    meta: time_45entriesFVyw8X9DjGBw5G0E8Qy6MWB8GJ1jK9VmslKPTkonod8Meta || {},
    component: () => import("/app/modules/hrm/pages/hrm/time-tracking/time-entries.vue")
  },
  {
    name: "products-pharmacy-dosage-forms",
    path: "/products/pharmacy/dosage-forms",
    component: () => import("/app/modules/products/pages/products/pharmacy/dosage-forms.vue")
  },
  {
    name: "reports-profit-maximizer",
    path: "/reports/profit-maximizer",
    component: () => import("/app/modules/reports/pages/reports/profit-maximizer/index.vue")
  },
  {
    name: "products-pharmacy-generic-names",
    path: "/products/pharmacy/generic-names",
    component: () => import("/app/modules/products/pages/products/pharmacy/generic-names.vue")
  },
  {
    name: "products-pharmacy-manufacturers",
    path: "/products/pharmacy/manufacturers",
    component: () => import("/app/modules/products/pages/products/pharmacy/manufacturers.vue")
  },
  {
    name: "hrm-contract-management-resource",
    path: "/hrm/contract-management/:resource()",
    meta: _91resource_93nVsWf2UStXkgyLAcutnG0YlYFE1ybOggA5ZJzxHKW4oMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/contract-management/[resource].vue")
  },
  {
    name: "hrm-document-management-resource",
    path: "/hrm/document-management/:resource()",
    meta: _91resource_93QKjMW0p1ShRHXjT2g_45DGwUNyEoXV7yNLHa6ZnHaJvvUMeta || {},
    component: () => import("/app/modules/hrm/pages/hrm/document-management/[resource].vue")
  },
  {
    name: "products-pharmacy-storage-conditions",
    path: "/products/pharmacy/storage-conditions",
    component: () => import("/app/modules/products/pages/products/pharmacy/storage-conditions.vue")
  }
]